import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import { EventPdvSaleProductReport } from '@/model/EventPdvSaleProductReport';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { ReportControllerProps } from '../../types';
import { SaleProductPdvContent } from './ui';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductPdv: React.FC<StateProps> = ({
  reportController,
  setState,
}): JSX.Element => {
  const { eventId, singleEvent } = reportController;
  const [pdvs, setPdvs] = useState<EventPdvSaleProductReport[]>([]);

  const handleGetSaleProducts = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventPdvSaleProductReport[]>(
        `event/report/${eventId}/sale-product/pdv?singleEvent=${singleEvent}`,
      );
      if (data) {
        setPdvs(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, []);
  return <SaleProductPdvContent pdvs={pdvs} />;
};
